var PageService = function() {
  this.saveProgress = function(blockView) {
    EF.module.save();
  };
};

module.exports = new PageService();